import { FeatureType } from "@/enums";
import { RootState } from "@/store";
import { Feature } from "@/types/Feature";
import { Controllers } from "@infoland/iprova-api";
import { ActionTree } from "vuex";

//state type
export interface FeaturesState {
    Features: Feature[];
}

export function initialize(): FeaturesState {
    return {
        Features: []
    };
}

//initial state
const state: FeaturesState = initialize();

//getters for this store
const getters = {
    /**
     * The current Feature list
     * @param state The state to read from
     */
    GetCurrentFeatures(state: FeaturesState): Feature[] {
        return state.Features;
    }
};

// mutations for this store
const mutations = {
    /**
     * Set the current Feature list
     * @param state The state to write to
     * @param Feature  the list of Feature
     */
    _currentFeatures(state: FeaturesState, Features: Feature[]): void {
        // undefined should become null
        if (!Features) Features = null;

        state.Features = Features;
    }
};

// actions for this store
const actions: ActionTree<FeaturesState, RootState> = {
    /**
     * Loads the features list
     * @param context The context of the action
     */
    async loadCurrentFeatures({ commit }): Promise<Feature[]> {
        // load list of features
        const features = await Controllers.GenericController.getAsync<Feature[]>("features");

        commit("_currentFeatures", features);
        return features;
    },

    /**
     * Get a feature by type
     * @param featureType The feature type
     */
    async GetFeatureByType({ commit }, featureType: FeatureType): Promise<Feature> {
        if (state.Features.length == 0) {
            const features = await Controllers.GenericController.getAsync<Feature[]>("features");
            commit("_currentFeatures", features);
        }

        return state.Features.find(x => x.name == featureType);
    }
};

// export the namespace
export const namespace = "features";

// export the store 'module'
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
